package it.neckar.projects.pvplanner

import it.neckar.runtime.context.ServiceHost
import it.neckar.runtime.context.DeploymentStage
import it.neckar.runtime.context.ExecutionEnvironment
import it.neckar.runtime.context.FixedHostRegistry
import it.neckar.runtime.context.Hostname

/**
 * The host names for the PV planner
 */
enum class PvPlannerHost(
  override val hostname: Hostname,
  val hostnameShop: Hostname,

  val deploymentStage: DeploymentStage,
  val executionEnvironment: ExecutionEnvironment,

  ) : ServiceHost {
  Localhost(
    Hostname.localhost,
    Hostname.localhost,
    deploymentStage = DeploymentStage.Development,
    executionEnvironment = ExecutionEnvironment.LocalDev,
  ),
  Spielwiese(
    Hostname("spielwiese.pv.neckar.it"),
    Hostname("spielwiese.wunschsolar.de"),
    deploymentStage = DeploymentStage.Development,
    executionEnvironment = ExecutionEnvironment.Docker,
  ),
  Schaufenster(
    Hostname("schaufenster.pv.neckar.it"),
    Hostname("schaufenster.wunschsolar.de"),
    deploymentStage = DeploymentStage.Demo,
    executionEnvironment = ExecutionEnvironment.Docker,
  ),
  Production(
    Hostname("pv.neckar.it"),
    Hostname("wunschsolar.de"),
    deploymentStage = DeploymentStage.Production,
    executionEnvironment = ExecutionEnvironment.Docker
  ),
  ;

  companion object : FixedHostRegistry<PvPlannerHost> {
    override val knownHosts: List<PvPlannerHost> = entries.toList()

    override fun resolveHost(hostname: Hostname?): PvPlannerHost {
      return entries.find { it.hostname == hostname || it.hostnameShop == hostname } ?: Localhost
    }
  }
}
